import { post, get } from "@/request/http";

export const ToDecrypt = p => post("", p);

// 获取头部图片
export const getHeaderImage = id =>
  get("/getVirtualSimulationInfoV2", {
    id: id,
    param: "header_image"
  });

// 登录
export const loginWithCode = p => post("/webapp/wxLoginNew", p);

// 游客登录
export const touristLogin = () => post("/webapp/touristLogin");

// 退出
export const logout = () => post("/webapp/logout");
